import React, {FunctionComponent, useContext, useEffect, useState} from 'react';
import {FileTile} from '../../components/FileTile/FileTile';
import {FileContext} from '../../context/FileContext';
import {FileSection, File} from '../../models/file.model';
import './FilesSection.scss'
import {FilePreviewModal} from "../../components/FilePreviewModal/FilePreviewModal";

export const FilesSection: FunctionComponent = () => {
    const fileSection: FileSection = useContext(FileContext);
    const [currentFileInPreviewIndex, setCurrentFileInPreviewIndex] = useState<number | null>(null);
    const [isPreviewMode, setIsPreviewMode] = useState<boolean>(false);

    useEffect(() => {
        if (currentFileInPreviewIndex !== null) {
            setIsPreviewMode(true);
        } else {
            setIsPreviewMode(false);
        }
    }, [currentFileInPreviewIndex]);


    const closeModal = () => {
        setIsPreviewMode(false);
        setCurrentFileInPreviewIndex(null);
    };

    return (
        <section className='basic-section files-section'>
            <h3>Files</h3>

            <div className='files-container'>
                {
                    fileSection.is_files_visible && fileSection.files.length > 0
                        ? fileSection.files.map((file: File, index) => <div onClick={() => {setCurrentFileInPreviewIndex(index)}}><FileTile key={index} file={file}/></div>)
                        : <p>There are no files attached.</p>
                }
            </div>

            {
                isPreviewMode && currentFileInPreviewIndex !== null
                ? <FilePreviewModal files={fileSection.files}
                                    currentFileIndex={currentFileInPreviewIndex}
                                    onCloseModal={closeModal}
                    />
                : null
            }

        </section>
    );
}